import './UserFollowing.scss';

function UserFollowing() {
    return (
        <>
            Following
        </>
    )
}

export default UserFollowing
